import { formatLocale } from 'd3-format';

const locale = formatLocale({
  decimal: ',',
  thousands: '.',
  grouping: [3],
  currency: ['', ''],
  minus: '-',
  percent: '\u202f%',
});
export const getDutchDecimalFormat = (value: number, digits: number | null = 2): string => {
  if (digits === null) {
    return locale.format('$,')(value);
  }

  return locale.format(`$,.${digits}f`)(value);
};
export const formatNumberAsAmountString = (value: number, currency: string, digits = 2): string => {
  return `${currency} ${getDutchDecimalFormat(value, digits)}`;
};
